module.exports = __webpack_public_path__ + "static/media/3DPPA41.6d3b8b91.jpg";